define('app/shared/tables/driverTableDirective.js',["https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.12/d3.js"], function (d3) {
	function tableDirective() {
		return {
			restrict: 'E',
			replace: false,
			scope: {
				data: '=data'
			},
			templateUrl: 'app/shared/tables/driverTable.html',
			link: function(scope, element, attrs) {

				//element.find("tbody").css("height", attrs.height);

				scope.activeField = "points";
				scope.sortType = "num";

				scope.sortTable = function (field, type) {
					scope.activeField = field;
					scope.sortType = type;
					if (type === "num") {
						scope.items.sort(function(a,b) {
							return b[field] - a[field];
						});
					}
					if (type === "string") {
						scope.items.sort(function(a,b) {
							if(a[field] < b[field]) return -1;
							if(a[field] < b[field]) return 1;
							return 0;
							//return b[field] - a[field];
						});
					}
				}

				scope.isActive = function (field) {
					return field === scope.activeField;
				}

				scope.$watch('data', function (data) {
					if(data === undefined) {return;}
					scope.items = data;
					scope.sortTable(scope.activeField, scope.sortType);
				});

				//Virtual Scroll hack
				element.find("tbody").css("height", attrs.numDisplayed*30+8 + "px"); //height set to 5 * height of li, instead of attrs.height
				scope.scrollPosition = 0;
				scope.beginItem = 0;
				scope.endItem = Number(attrs.numDisplayed);
				scope.top = function (index) {
					return {'top': (index-scope.beginItem)*30+scope.scrollPosition + 'px'};
				}
				$(element).find("tbody").scroll(function() {
					scope.scrollPosition = $(this).scrollTop();
					scope.beginItem = scope.scrollPosition / 30;
					scope.endItem = scope.beginItem + Number(attrs.numDisplayed);
					scope.$apply();
				});
				scope.$watch('items', function (items) {
					if(!items) return;
					element.find("tbody tr:last-child").css("height", items.length*30-100 + "px").css("width", "1px");
				});

				
			}
		}
	}

  	return tableDirective;
});
